import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtomysoretourpackage() {



    const cardData = {




keyword: "Belgaum to Mysore Tour Package",

headingDescription: "Belgaum Taxi Service offers well-planned and comfortable Belgaum to Mysore tour packages for families, couples, friends, corporate groups, senior citizens, and travelers looking for a convenient Karnataka holiday. Our Belgaum to Mysore tour package can be customized according to your preferred travel dates, number of travelers, sightseeing requirements, vehicle type, and number of days. Choose from Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for individual travelers as well as larger groups. The package can include comfortable pickup from your preferred location in Belgaum, private cab transportation, sightseeing assistance, flexible travel schedules, and return transfers according to your itinerary. Travelers can explore Mysore's royal heritage, magnificent palaces, temples, gardens, viewpoints, and cultural attractions without worrying about local transportation. Whether you are planning a weekend getaway, family vacation, honeymoon trip, school or college tour, corporate outing, or multi-day Karnataka sightseeing journey, Belgaum Taxi Service provides dependable travel support from start to finish. With experienced drivers, clean vehicles, transparent package pricing, convenient booking, customizable itineraries, and 24/7 customer assistance, we make your Belgaum to Mysore tour comfortable, organized, and enjoyable.",

topPlaces: [
  {
    title: "Mysore Palace",
    description: "Mysore Palace is the city's most iconic attraction and a major highlight of Karnataka tourism. Its grand architecture, royal interiors, illuminated evening appearance, and fascinating history make it an essential stop on a Mysore sightseeing tour."
  },
  {
    title: "Chamundi Hills",
    description: "Chamundi Hills offers panoramic views of Mysore and is home to the famous Chamundeshwari Temple. The hill is an important spiritual and sightseeing destination for families, pilgrims, and tourists."
  },
  {
    title: "Brindavan Gardens",
    description: "Brindavan Gardens is a beautifully landscaped garden near the Krishnaraja Sagar Dam, famous for its musical fountain, illuminated evenings, colorful flower arrangements, and peaceful surroundings."
  },
  {
    title: "Mysore Zoo",
    description: "Mysore Zoo is one of the popular family attractions in the city, featuring a wide variety of animals, birds, and wildlife in a spacious environment. It is a convenient addition to family and group tour itineraries."
  },
  {
    title: "St. Philomena's Cathedral",
    description: "St. Philomena's Cathedral is a magnificent Gothic-style church and one of Mysore's prominent architectural landmarks. Its impressive structure and peaceful surroundings attract visitors interested in history, architecture, and culture."
  },
  {
    title: "Srirangapatna",
    description: "Srirangapatna is a historic island town near Mysore associated with Tipu Sultan and the Kingdom of Mysore. Visitors can explore forts, temples, palaces, and other important historical attractions."
  },
  {
    title: "Coorg",
    description: "Coorg is a scenic hill destination known for coffee plantations, green landscapes, waterfalls, forests, and pleasant weather. It can be added to an extended Belgaum-Mysore holiday itinerary for travelers seeking nature and relaxation."
  },
  {
    title: "Ooty",
    description: "Ooty is a popular hill station known for tea estates, misty mountains, gardens, lakes, and pleasant weather. Travelers planning a longer South India tour can combine Mysore and Ooty in one private cab itinerary."
  },
  {
    title: "Wayanad",
    description: "Wayanad is a scenic destination known for forests, waterfalls, wildlife, caves, plantations, and mountain landscapes. It is suitable for travelers looking to extend their Mysore holiday with a nature-focused trip."
  },
  {
    title: "Bangalore",
    description: "Bangalore is a major technology and business hub with IT parks, corporate offices, shopping destinations, restaurants, and entertainment attractions. It can be included as an additional stop when planning a multi-city Karnataka tour from Belgaum."
  }
],




"services": [
  {
    "name": "Belgaum to Mysore Tour Package",
    "description": "Book Belgaum to Mysore Tour Package for a comfortable and memorable holiday with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family vacations, sightseeing, temple visits, and weekend getaways with customizable one way and round trip tour plans."
  },
  {
    "name": "Belgaum to Mysore Tour",
    "description": "Plan your Belgaum to Mysore Tour with reliable cab services offering safe travel, experienced drivers, comfortable vehicles, and flexible itineraries. Explore Mysore Palace, Chamundi Hills, Brindavan Gardens, St. Philomena's Church, and other famous attractions with complete convenience."
  },
  {
    "name": "Belgaum to Mysore Package",
    "description": "Choose Belgaum to Mysore Package for an affordable travel experience with hotel pickup, comfortable transportation, and flexible schedules. Our tour packages are perfect for couples, families, corporate groups, and holiday travelers."
  },
  {
    "name": "Belgaum to Mysore Cab Package",
    "description": "Book Belgaum to Mysore Cab Package with professional chauffeurs and premium AC vehicles for a hassle-free road trip. Enjoy customized sightseeing, doorstep pickup, and comfortable travel throughout your journey."
  },
  {
    "name": "Belgaum to Mysore Taxi Package",
    "description": "Hire Belgaum to Mysore Taxi Package for convenient travel with transparent pricing, clean vehicles, and experienced drivers. Our taxi packages are suitable for family vacations, pilgrimage trips, and business travel."
  },
  {
    "name": "Belgaum to Mysore One Way Cab",
    "description": "Reserve Belgaum to Mysore One Way Cab for economical single-trip travel with fixed pricing, AC vehicles, and reliable chauffeur service. Enjoy a smooth and comfortable intercity journey."
  },
  {
    "name": "Belgaum to Mysore Round Trip Package",
    "description": "Choose Belgaum to Mysore Round Trip Package for flexible return travel with affordable tour plans, comfortable vehicles, and experienced drivers. Perfect for weekend holidays and sightseeing tours."
  },
  {
    "name": "Belgaum to Mysore Holiday Package",
    "description": "Book Belgaum to Mysore Holiday Package for a relaxing vacation with customized travel plans, spacious vehicles, and professional chauffeurs. Experience hassle-free travel with flexible itineraries."
  },
  {
    "name": "Belgaum to Mysore Sightseeing Tour",
    "description": "Enjoy Belgaum to Mysore Sightseeing Tour covering Mysore Palace, Chamundi Hills, Brindavan Gardens, Mysore Zoo, St. Philomena's Church, and other popular attractions with comfortable cab services."
  },
  {
    "name": "Belgaum to Mysore Family Tour",
    "description": "Book Belgaum to Mysore Family Tour with spacious AC vehicles and experienced drivers for a safe and enjoyable vacation. Our packages are designed for families seeking comfortable and memorable travel."
  },
  {
    "name": "Belgaum to Mysore Innova Crysta Tour",
    "description": "Travel with Belgaum to Mysore Innova Crysta Tour for premium comfort, spacious seating, luxury interiors, and ample luggage space. Ideal for family holidays, corporate travel, and group tours."
  },
  {
    "name": "Belgaum to Mysore Ertiga Tour",
    "description": "Choose Belgaum to Mysore Ertiga Tour for comfortable 6 to 7 seater travel with affordable pricing, AC comfort, and professional chauffeurs. Perfect for families and small groups."
  },
  {
    "name": "Belgaum to Mysore Sedan Tour",
    "description": "Book Belgaum to Mysore Sedan Tour for economical and comfortable travel with clean AC cars and experienced drivers. Suitable for couples, business travelers, and small families."
  },
  {
    "name": "Cheap Belgaum to Mysore Tour Package",
    "description": "Find Cheap Belgaum to Mysore Tour Package with affordable fares, quality vehicles, and reliable drivers. Enjoy budget-friendly sightseeing and holiday travel without compromising comfort or safety."
  },
  {
    "name": "Best Belgaum to Mysore Tour Package",
    "description": "Choose the Best Belgaum to Mysore Tour Package offering premium vehicles, experienced chauffeurs, transparent pricing, and customized sightseeing itineraries for an unforgettable travel experience."
  },
  {
    "name": "Online Belgaum to Mysore Tour Booking",
    "description": "Complete Online Belgaum to Mysore Tour Booking with instant confirmation, easy reservations, and multiple vehicle options. Plan your holiday quickly with our convenient online booking service."
  },
  {
    "name": "Belgaum to Mysore Travel Package",
    "description": "Book Belgaum to Mysore Travel Package for a comfortable road trip with professional drivers, well-maintained vehicles, and flexible sightseeing plans suitable for all types of travelers."
  },
  {
    "name": "Belgaum to Mysore Car Rental",
    "description": "Hire Belgaum to Mysore Car Rental with driver for family vacations, business visits, sightseeing tours, and holiday travel. Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Belgaum to Mysore Tour Fare",
    "description": "Get affordable Belgaum to Mysore Tour Fare with transparent pricing, competitive packages, and multiple vehicle choices. Select the best tour plan according to your travel budget."
  },
  {
    "name": "Belgaum to Mysore Cab Price",
    "description": "Check Belgaum to Mysore Cab Price and choose from affordable Sedan, Ertiga, Innova Crysta, and SUV options with flexible booking and premium travel comfort."
  },
  {
    "name": "Belgaum to Mysore Weekend Tour",
    "description": "Book Belgaum to Mysore Weekend Tour for a refreshing short vacation with comfortable transportation, experienced chauffeurs, and customizable sightseeing plans covering Mysore's top attractions."
  },
  {
    "name": "Belgaum to Mysore Tour by Cab",
    "description": "Travel from Belgaum to Mysore Tour by Cab with safe, reliable, and comfortable transportation. Enjoy experienced drivers, premium vehicles, flexible travel schedules, and personalized tour packages for families, couples, and corporate travelers."
  }
],
"tableData": [
  ["Belgaum to Mysore Tour Package", "Belgaum to Mysore Tour"],
  ["Belgaum to Mysore Package", "Belgaum to Mysore Cab Package"],
  ["Belgaum to Mysore Taxi Package", "Belgaum to Mysore One Way Cab"],
  ["Belgaum to Mysore Round Trip Package", "Belgaum to Mysore Holiday Package"],
  ["Belgaum to Mysore Sightseeing Tour", "Belgaum to Mysore Family Tour"],
  ["Belgaum to Mysore Innova Crysta Tour", "Belgaum to Mysore Ertiga Tour"],
  ["Belgaum to Mysore Sedan Tour", "Cheap Belgaum to Mysore Tour Package"],
  ["Best Belgaum to Mysore Tour Package", "Online Belgaum to Mysore Tour Booking"],
  ["Belgaum to Mysore Travel Package", "Belgaum to Mysore Car Rental"],
  ["Belgaum to Mysore Tour Fare", "Belgaum to Mysore Cab Price"],
  ["Belgaum to Mysore Weekend Tour", "Belgaum to Mysore Tour by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Well-Planned Belgaum to Mysore Tour Package",
    WhyChoosedescription: "Explore Mysore comfortably from Belgaum with a private tour package designed around sightseeing, flexible travel schedules, and convenient transportation throughout your trip."
  },
  {
    WhyChooseheading: "Explore Mysore at Your Own Pace",
    WhyChoosedescription: "Enjoy the freedom to spend more time at attractions that interest you instead of following rigid public transport schedules."
  },
  {
    WhyChooseheading: "Private Cab for the Complete Trip",
    WhyChoosedescription: "Travel with your own dedicated vehicle and chauffeur from Belgaum to Mysore, giving your family or group greater privacy and convenience."
  },
  {
    WhyChooseheading: "Comfortable Cars for Families & Groups",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and other spacious options depending on the number of travellers and luggage."
  },
  {
    WhyChooseheading: "Sightseeing Can Be Customized",
    WhyChoosedescription: "Plan your Mysore sightseeing according to your interests, whether you prefer heritage attractions, gardens, temples, palaces, or family-friendly places."
  },
  {
    WhyChooseheading: "Suitable for Weekend Getaways",
    WhyChoosedescription: "A private Belgaum to Mysore tour is a convenient option for short holidays, family vacations, couple trips, group outings, and extended weekend plans."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs",
    WhyChoosedescription: "Professional drivers help make the road journey and local sightseeing easier while handling transportation according to your planned itinerary."
  },
  {
    WhyChooseheading: "Flexible Tour Duration",
    WhyChoosedescription: "Choose a suitable itinerary for a one-day visit or a multi-day Mysore holiday depending on the attractions you want to cover."
  }
]

};

const faqData = [
  {
    question: "What is included in a Belgaum to Mysore Tour Package?",
    answer: "A tour package can include private cab transportation, Belgaum pickup and Mysore sightseeing or drop services. The exact inclusions depend on the itinerary and selected vehicle."
  },
  {
    question: "Can I customize the Mysore sightseeing itinerary?",
    answer: "Yes, the sightseeing plan can be adjusted according to your available time, preferred attractions, and travel requirements."
  },
  {
    question: "Which vehicles are available for a Mysore tour?",
    answer: "Sedan, Ertiga, Innova, Innova Crysta, and SUV options are available depending on group size, luggage, and comfort preferences."
  },
  {
    question: "Is this package suitable for families?",
    answer: "Yes, private tour packages are convenient for families because they provide flexible timings, dedicated transportation, and comfortable sightseeing."
  },
  {
    question: "Can I book a Belgaum to Mysore one-way tour?",
    answer: "Yes, one-way transportation to Mysore can be arranged if you only need a private cab for reaching your destination."
  },
  {
    question: "Can I include Mysore sightseeing in the return trip?",
    answer: "Yes, a round-trip itinerary can be planned with sightseeing stops based on your available travel time and selected package."
  },
  {
    question: "Can I book a Mysore tour for a larger group?",
    answer: "Yes, suitable spacious vehicles can be arranged for families and groups according to the number of passengers."
  },
  {
    question: "Are tolls and parking charges included in the package?",
    answer: "Toll, parking, entry tickets, and other additional expenses depend on the selected package and are clarified while preparing the quotation."
  },
  {
    question: "Can I start the Mysore tour from Belgaum Airport?",
    answer: "Yes, pickup can be arranged from Belgaum Airport or another preferred location in Belgaum before starting the journey to Mysore."
  },
  {
    question: "How can I book a Belgaum to Mysore Tour Package?",
    answer: "Share your travel dates, number of passengers, pickup location, preferred vehicle, trip duration, and sightseeing requirements to receive a suitable tour quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Desai",
    feedback: "Our family chose the Belgaum to Mysore tour for a weekend holiday. The private car gave us plenty of flexibility, and we could comfortably manage sightseeing along with the return journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priyanka Patil",
    feedback: "The Mysore trip was planned around our family schedule, which made the holiday much more enjoyable. The vehicle was spacious and the driver was helpful throughout the tour.",
    rating: 5
  }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];











    return (
        <div>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtomysoretourpackage;